import { Checkbox, CardContent, Typography, TextField } from "@mui/material";
import ImageUpload from "./ImageUpload";
import CloseIcon from "@mui/icons-material/Close";

import commoncss from "../../myfin_v2/css/common.module.css";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";
import InputGroup from "../../myfin_v2/elements/InputGroup";


const AddFooters = ({
  sampleFooters,
  Footers,
  handleCheckBox,
  handleFooters,
  uploadImages,
  close,
  popFooterCount,
  key
}) => {

  let remainingFooters = close !== 0 ? sampleFooters.filter(ele => !Footers.slice(0, close).map(item => item.sheets).flat().includes(ele)) : sampleFooters;
  if (remainingFooters.length === 0 || (remainingFooters.length === 1 && remainingFooters.includes('All Pages'))) {
    popFooterCount(close);
  }
  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const handleChecked = (close, footer) => {
    const Footersheet = Footers.find(ele => ele.footer === close);
    if (Footersheet === undefined) {
      return false
    }
    let RefinedSampleFooters = remainingFooters.filter((head) => head !== 'All Pages');
    let all_present = RefinedSampleFooters.every(ele => Footersheet.sheets.includes(ele))
    if (Footersheet) {
      return Footersheet.sheets.includes(footer) || Footersheet.sheets.includes('All Pages') || all_present || false;
    } else {
      return false
    }
  }

  return (
    <CardContent>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // Distributes space between text and icon
          alignItems: "center", // Vertically centers the content
          padding: "0 10px", // Adds padding on the left and right
        }}
      >
        <span className={commoncss.label3}>
          Add Footer to:</span>
        {close !== 0 && <CloseIcon
          className="custom-redcolor ml-1 mt-1"
          style={{ cursor: "pointer", backgroundColor: 'lightpink', borderRadius: '50%' }}
          onClick={() => { popFooterCount(close) }}
        />}
      </div>
      <div className="d-flex flex-wrap p-2 py-3" style={{ gap: "10px" }}>

        {remainingFooters.map((footer, index) => (
          <div
          >
            <input type="checkbox"
              name="sheet1"
              value={footer}
              onChange={(e) => handleCheckBox(e, close)}
              checked={
                handleChecked(close, footer)
              }
              className={adminPortalCss.customCheckbox}
            /> <span className={`${commoncss.label6} ${commoncss.headingColor} ${commoncss.vaSuper} ${commoncss.fs16}`}>{footer}</span>
          </div>
        ))}
      </div>
      <InputGroup
        inputs={[
          <>
            <textarea
              className={commoncss.fs15}
              rows={1}
              name="footer1"
              placeholder="footer Data"
              onChange={(e) => handleFooters(e, close)}
            />
          </>,
        ]}
      />
      <div>
        <ImageUpload uploadImages={uploadImages} name={"image1"} />
      </div>
    </CardContent>
  );
};

export default AddFooters;
